// src/components/extensions/demos.ts
//
// The demo registry.
//
// Mirrors icons.ts: the config names a demo, this map resolves it to a
// component, and typing the map as Record<ExtensionDemo, ComponentType> is what
// makes the two check against each other. A demo named in the config with
// nothing registered here fails the build rather than rendering an empty slot.
//
// Kept separate from icons.ts because the two answer different questions. The
// icon registry is a leaf — a name to a glyph, no state. A demo is a component
// with its own lifecycle: it animates, it holds state, and it needs to be
// unmounted cleanly when the card unmounts. That is worth a file of its own.
import type { ComponentType } from 'react';

import type { ExtensionDemo } from '../../config/siteConfig';
import FoldDemo from './FoldDemo';
import RegexDemo from './RegexDemo';

export const EXTENSION_DEMOS: Record<ExtensionDemo, ComponentType> = {
  fold: FoldDemo,
  regex: RegexDemo,
};

/**
 * Resolves an entry's optional demo name. Returns null rather than a fallback
 * component, because "this extension has no demo" is a legitimate state and
 * should render nothing at all.
 */
export const demoFor = (name: ExtensionDemo | undefined): ComponentType | null =>
  (name && EXTENSION_DEMOS[name]) || null;
